/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { AdminResetDTO, ChangePasswordDTO, ForgotPasswordDTO, ResetPasswordDTO } from '../models';

@Injectable({ providedIn: 'root' })
export class PasswordsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Send password reset instructions via email
   */

  forgotPassword<TData = void>(forgotPasswordDTO: ForgotPasswordDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/passwords/forgot`, forgotPasswordDTO);
  }
  /**
   * @summary Reset a user password as an admin
   */

  resetUserPassword<TData = void>(adminResetDTO: AdminResetDTO): Observable<TData> {
    return this.http.put<TData>(`/clients/v1/passwords/admin-reset`, adminResetDTO);
  }
  /**
   * @summary Reset user password using reset code
   */

  resetPassword<TData = void>(resetPasswordDTO: ResetPasswordDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/passwords/reset`, resetPasswordDTO);
  }
  /**
   * @summary Change the logged-in user’s password
   */

  changePassword<TData = void>(changePasswordDTO: ChangePasswordDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/passwords/change`, changePasswordDTO);
  }
}
